import { render, staticRenderFns } from "./bad-result.vue?vue&type=template&id=6b6691ca&scoped=true&"
import script from "./bad-result.vue?vue&type=script&lang=js&"
export * from "./bad-result.vue?vue&type=script&lang=js&"
import style0 from "./bad-result.vue?vue&type=style&index=0&id=6b6691ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6691ca",
  null
  
)

export default component.exports